import SelectDinamico from "../../SelectDinamico";
import ConsultaContaContabil from "../../../../lib/json/consultas/ContaContabil.json"

function SelectContaContabil({campoContaContabil, changeContaContabil, queryContaContabil, disabled = false, empresaLogada, returnOriginal = false, loadDefault = true, bindItem, field, label="Conta Contábil", selectUnique = false, showNoFilter=false, valueTrim = false}){
    const cConsultaDefault = ConsultaContaContabil.consulta + " WHERE CT1_FILIAL = FILIAL(CT1) AND CT1_CLASSE = 2 AND CT1_BLOQ = 2 "
    const consulta = queryContaContabil || ( loadDefault ? cConsultaDefault : '' )
    const empresaFilial = empresaLogada || localStorage.getItem('empresaFilial')
    const contaContabilValue = bindItem ? bindItem[field] : campoContaContabil;
    let cValFmt = "CT1_CONTA"
    
    if (valueTrim){
        cValFmt = "CT1_CONTA.trim()"
    }

    return (
        <SelectDinamico            
            label={label}
            cText="CT1_CONTA + ' - ' + item.CT1_DESC01"
            cValue={cValFmt}
            campoValue={contaContabilValue}
            consulta={consulta}
            tabela={ConsultaContaContabil.tabelas}
            isMultiplo={false}
            EmpresaLogada={empresaFilial}
            onchange={(e) => { changeContaContabil(e) }}
            showNoFilter={showNoFilter}
            selectOptionUnique={selectUnique}
            returnOrigem={returnOriginal}
            bindItem={bindItem}
            field={field}
            disabled={disabled}
        />
    )
}

export default SelectContaContabil;